import './polyfills';
import {
    applyRuntimeConfig,
    loadRuntimeConfig,
    showBootError,
} from './infrastructure/runtimeConfig';
import { loadTrackingScripts } from './infrastructure/trackingScripts';

loadRuntimeConfig()
    .then((config) => {
        applyRuntimeConfig(config);
        loadTrackingScripts(config.globalConfig);

        return import('./bootstrap');
    })
    .catch((err) => {
        console.error('Failed to load application:', err);
        showBootError();
    });
